<div class="header">
    <ng-container *ngIf="!countScheduleTime">
        <h1>Book your Financial Clarity call with an adviser.</h1>
        <!-- <p>{{ scheduleTitle }}</p> -->
        <p>Congratulations! You have set up your profile. Now book your Financial Clarity call with an adviser.</p>
        <p>Any issues or questions email <a class="email" href="mailto:support@wealthmaximiser.com.au"> support@wealthmaximiser.com.au </a></p>
    </ng-container>

    <ng-container *ngIf="countScheduleTime">
        <h1>Welcome back!</h1>
        <p>It’s time to schedule your next Financial Adviser check-in</p>
    </ng-container>
</div>

<div #calendarElem class="widget" [ngClass]="{ 'disabled-select': isFileNotes }"></div>
